import { ConfigurationService } from '@sc/data-access-configuration';
import { Dossier } from '@sc/data-access-models';
import { PlanningCalendarService } from '../../planning-calendar.service';

export abstract class AbstractTooltipService {
  protected constructor(
    protected planningCalendarService: PlanningCalendarService,
    protected configurationService: ConfigurationService
  ) {}

  abstract generateToolTip(info, simplified?: boolean);

  generateDossierInformationIcons(dossier: Dossier) {
    return this.planningCalendarService.generateIconsForTooltipEvent(
      dossier,
      this.configurationService
    );
  }
}
